import {ErrorHandler, Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {error$} from '../app.component';

export const lookupErrorMessage = (error: any): string => {
  if (typeof error === 'string') {
    return error;
  }
  if (typeof error !== 'object') {
    return JSON.stringify(error);
  }
  if (!!error.error) {
    return lookupErrorMessage(error.error);
  }
  if (!!error.sqlerrm) {
    return lookupErrorMessage(error.sqlerrm);
  }
  return JSON.stringify(error);
};

@Injectable()
export class AppErrorHandler implements ErrorHandler {


  handleError(rawError: any) {
    if (rawError === null) {
      return;
    }
    const error = rawError.hasOwnProperty('rejection') ? rawError.rejection : rawError;
    let errorType = 'Error';
    if (error?.extensions && error?.message) {
      errorType = 'GraphQLError'
    } else if (error instanceof TypeError) {
      errorType = 'Type Error'
    } else if (error instanceof HttpErrorResponse) {
      errorType = 'HttpErrorResponse'
    } else if (error instanceof Error) {
      errorType = 'Error'
    }
    console.log({
      error, errorType
    })
    error$.set({
      error, errorType
    });
  }

}
